import React, { useState, useRef, useEffect } from 'react';

const FPS_Dist_Active_Details = ({ data, onDrillDown, onBack }) => {
    const [officeData, setOfficeData] = useState(null);
    const [loindaysData, setLoindaysData] = useState(null);
    const [loadingRR, setLoadingRR] = useState(false);
    const [currentDistCode, setCurrentDistCode] = useState(null);
    const [currentDistName, setCurrentDistName] = useState('');
    const [currentOfficeName, setCurrentOfficeName] = useState('');
    const [showTopButton, setShowTopButton] = useState(false);

    const officeTableRef = useRef(null);
    const loindaysTableRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            setShowTopButton(window.scrollY > 300);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const detailsRRHandler = async (distCode, distName, month, year, day) => {
        setLoadingRR(true);
        try {
            let url = '';
            let requestBody = {};

            if (day === "30") {
                url = `${process.env.REACT_APP_URL_FPS}/api/fps/office-active-details`;
                requestBody = {
                    distCode: distCode,
                    month: month.toString(),
                    year: year.toString(),
                    day: day
                };
                setCurrentDistCode(distCode);
                setCurrentDistName(distName);
                setCurrentOfficeName('');
            } else {
                url = `${process.env.REACT_APP_URL_FPS}/api/fps/loindays-details`;
                requestBody = {
                    distCode: distCode,
                    officeCode: "",
                    month: month.toString(),
                    year: year.toString(),
                    day: day
                };
                setCurrentDistCode(distCode);
                setCurrentDistName(distName);
                setCurrentOfficeName('');
            }

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });
            const result = await response.json();

            if (day === "30") {
                setOfficeData(result);
                setLoindaysData(null);

                setTimeout(() => {
                    if (officeTableRef.current) {
                        officeTableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 100);
            } else {
                setOfficeData(null);
                setLoindaysData(result);
                setTimeout(() => {
                    if (loindaysTableRef.current) {
                        loindaysTableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 100);
            }

        } catch (error) {
            console.error('Error fetching drill-down details:', error);
        } finally {
            setLoadingRR(false);
        }
    };

    const handleOfficeValueClick = async (officeCode, officeName, month, year, day) => {
        setLoadingRR(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_URL_FPS}/api/fps/loindays-details`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    distCode: currentDistCode,
                    officeCode: officeCode,
                    month: month.toString(),
                    year: year.toString(),
                    day: day
                }),
            });
            const result = await response.json();
            setLoindaysData(result);
            setCurrentOfficeName(officeName);

            setTimeout(() => {
                if (loindaysTableRef.current) {
                    loindaysTableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);

        } catch (error) {
            console.error('Error fetching office drill-down details:', error);
        } finally {
            setLoadingRR(false);
        }
    };

    const handleBackToDistrict = () => {
        setOfficeData(null);
        setLoindaysData(null);
        setCurrentDistCode(null);
        setCurrentDistName('');
        setCurrentOfficeName('');
    };

    const getMonthName = (monthNum) => {
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        return months[monthNum - 1] || '';
    };

    const getDayRangeText = (day) => {
        switch (day) {
            case '0': return '0 Days';
                        case '1': return '1 to 5 Days';

            case '6': return '6 to 10 Days';
            case '11': return '11 to 15 Days';
            case '16': return '16 to 20 Days';
            case '20': return 'Greater than 20 days';
            default: return '';
        }
    };

    const getHeadingText = () => {
        if (currentOfficeName) {
            return `${getDayRangeText(loindaysData.day)} Logged in FPS Details for ${currentDistName}-${currentOfficeName} for ${getMonthName(loindaysData.month)}'${loindaysData.year}`;
        } else {
            return `${getDayRangeText(loindaysData.day)} Logged in FPS Details for ${currentDistName} for ${getMonthName(loindaysData.month)}'${loindaysData.year}`;
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    if (data.listSize === 0) {
        return (
            <div style={{ textAlign: 'center', color: 'red', marginTop: '20px' }}>

                Details Not Found

                {showTopButton && (
                    <button
                        onClick={scrollToTop}
                        style={{
                            position: 'fixed',
                            right: '18px',
                            bottom: '18px',
                            zIndex: 9999,
                            backgroundColor: '#f1872bff',
                            color: '#100d0dff',
                            border: 'none',
                            padding: '12px 14px',
                            borderRadius: '20px',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            fontSize: '14px'
                        }}
                        title="Back to Top"
                    >
                        Top
                    </button>
                )}
            </div>
        );
    }

    return (
        <div style={{ minHeight: '50vh', paddingBottom: '70px' }}>
            {/* District Table */}
            <div style={{ marginBottom: '40px' }}>
                <table style={{
                    width: '70%',
                    margin: '0 auto',
                    borderCollapse: 'collapse',
                    border: '1px solid #ddd'
                }}>
                    <tbody>
                        <tr className="tableheader">
                            <td colSpan="12" style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>
                                FPS Active for {getMonthName(data.month)}'{data.year}
                            </td>
                        </tr>
                        <tr className="tableheader">
                            <td rowSpan="2" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                Sl No
                            </td>
                            <td rowSpan="2" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                District
                            </td>

                            <td colSpan="1" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                0 Days
                            </td>

                            <td colSpan="1" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                1 to 5 Days
                            </td>
                            <td colSpan="1" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                6 to 10 Days
                            </td>
                            <td colSpan="1" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                11 to 15 Days
                            </td>
                            <td colSpan="1" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                16 to 20 Days
                            </td>
                            <td colSpan="1" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                Greater than 20 days
                            </td>
                        </tr>
                        <tr className="tableheader">
                            <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Logged in</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Logged in</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Logged in</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Logged in</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Logged in</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Logged in</td>
                        </tr>

                        {data.list.map((item, index) => (
                            <tr key={index}>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                    {index + 1}
                                </td>
                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                    <a
                                        style={{
                                            cursor: 'pointer',
                                            color: 'black',
                                            textDecoration: 'underline'
                                        }}
                                        onClick={() => detailsRRHandler(item.distCode, item.distNameEn, data.month, data.year, '30')}
                                    >
                                        {item.distNameEn}
                                    </a>
                                </td>

                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>
                                    {item.oneFps > 0 ? (
                                        <a
                                            style={{
                                                cursor: 'pointer',
                                                color: 'black',
                                                textDecoration: 'underline'
                                            }}
                                            onClick={() => detailsRRHandler(item.distCode, item.distNameEn, data.month, data.year, '0')}
                                        >
                                            {item.zeroFps}
                                        </a>
                                    ) : (
                                        item.oneFps
                                    )}
                                </td>


                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>
                                    {item.oneFps > 0 ? (
                                        <a
                                            style={{
                                                cursor: 'pointer',
                                                color: 'black',
                                                textDecoration: 'underline'
                                            }}
                                            onClick={() => detailsRRHandler(item.distCode, item.distNameEn, data.month, data.year, '1')}
                                        >
                                            {item.oneFps}
                                        </a>
                                    ) : (
                                        item.oneFps
                                    )}
                                </td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>
                                    {item.twoFps > 0 ? (
                                        <a
                                            style={{
                                                cursor: 'pointer',
                                                color: 'black',
                                                textDecoration: 'underline'
                                            }}
                                            onClick={() => detailsRRHandler(item.distCode, item.distNameEn, data.month, data.year, '6')}
                                        >
                                            {item.twoFps}
                                        </a>
                                    ) : (
                                        item.twoFps
                                    )}
                                </td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>
                                    {item.threeFps > 0 ? (
                                        <a
                                            style={{
                                                cursor: 'pointer',
                                                color: 'black',
                                                textDecoration: 'underline'
                                            }}
                                            onClick={() => detailsRRHandler(item.distCode, item.distNameEn, data.month, data.year, '11')}
                                        >
                                            {item.threeFps}
                                        </a>
                                    ) : (
                                        item.threeFps
                                    )}
                                </td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>
                                    {item.fourFps > 0 ? (
                                        <a
                                            style={{
                                                cursor: 'pointer',
                                                color: 'black',
                                                textDecoration: 'underline'
                                            }}
                                            onClick={() => detailsRRHandler(item.distCode, item.distNameEn, data.month, data.year, '16')}
                                        >
                                            {item.fourFps}
                                        </a>
                                    ) : (
                                        item.fourFps
                                    )}
                                </td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>
                                    {item.fiveFps > 0 ? (
                                        <a
                                            style={{
                                                cursor: 'pointer',
                                                color: 'black',
                                                textDecoration: 'underline'
                                            }}
                                            onClick={() => detailsRRHandler(item.distCode, item.distNameEn, data.month, data.year, '20')}
                                        >
                                            {item.fiveFps}
                                        </a>
                                    ) : (
                                        item.fiveFps
                                    )}
                                </td>
                            </tr>
                        ))}

                        <tr className="tableheader">
                            <td colSpan="2" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Total</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{data.zeroFps}</td>

                            <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{data.oneFps}</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{data.twoFps}</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{data.threeFps}</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{data.fourFps}</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{data.fiveFps}</td>
                        </tr>
                    </tbody>
                </table>
            </div>



            {loadingRR && (
                <div style={{ textAlign: 'center', marginTop: '20px 0' }}>
                    <img src="https://epos.assam.gov.in/images/progress.gif" alt="Loading..." />
                </div>
            )}


            {/* Office table*/}
            {officeData && officeData.list && officeData.list[0] && (
                <div ref={officeTableRef} style={{ marginBottom: '40px', marginTop: '30px' }}>
                    <table style={{
                        width: '70%',
                        margin: '0 auto',
                        borderCollapse: 'collapse',
                        border: '1px solid #ddd'
                    }}>
                        <tbody>
                            <tr  className="tableheader">
                                <td colSpan="12" style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>
                                    FPS Active for {currentDistName} - {getMonthName(officeData.month)}'{officeData.year}
                                </td>
                            </tr>
                            <tr  className="tableheader">
                                <td rowSpan="2" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                    Sl No
                                </td>
                                <td rowSpan="2" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                    Office
                                </td>

                                 <td colSpan="1" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                    0  Days
                                </td>

                                <td colSpan="1" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                    1 to 5 Days
                                </td>
                                <td colSpan="1" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                    6 to 10 Days
                                </td>
                                <td colSpan="1" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                    11 to 15 Days
                                </td>
                                <td colSpan="1" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                    16 to 20 Days
                                </td>
                                <td colSpan="1" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                    Greater than 20 days
                                </td>
                            </tr>
                            <tr  className="tableheader">
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Logged in</td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Logged in</td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Logged in</td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Logged in</td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Logged in</td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Logged in</td>
                            </tr>

                            {officeData.list.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                        {index + 1}
                                    </td>
                                    <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                        {item.officeNameEn}
                                    </td>



                                          <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>
                                        {item.zeroFps > 0 ? (
                                            <a
                                                style={{
                                                    cursor: 'pointer',
                                                    color: 'black',
                                                    textDecoration: 'underline'
                                                }}
                                                onClick={() => handleOfficeValueClick(item.officeCode, item.officeNameEn, officeData.month, officeData.year, '0')}
                                            >
                                                {item.zeroFps}
                                            </a>
                                        ) : (
                                            item.zeroFps
                                        )}
                                    </td>


                                    <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>
                                        {item.oneFps > 0 ? (
                                            <a
                                                style={{
                                                    cursor: 'pointer',
                                                    color: 'black',
                                                    textDecoration: 'underline'
                                                }}
                                                onClick={() => handleOfficeValueClick(item.officeCode, item.officeNameEn, officeData.month, officeData.year, '1')}
                                            >
                                                {item.oneFps}
                                            </a>
                                        ) : (
                                            item.oneFps
                                        )}
                                    </td>
                                    <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>
                                        {item.twoFps > 0 ? (
                                            <a
                                                style={{
                                                    cursor: 'pointer',
                                                    color: 'black',
                                                    textDecoration: 'underline'
                                                }}
                                                onClick={() => handleOfficeValueClick(item.officeCode, item.officeNameEn, officeData.month, officeData.year, '6')}
                                            >
                                                {item.twoFps}
                                            </a>
                                        ) : (
                                            item.twoFps
                                        )}
                                    </td>
                                    <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>
                                        {item.threeFps > 0 ? (
                                            <a
                                                style={{
                                                    cursor: 'pointer',
                                                    color: 'black',
                                                    textDecoration: 'underline'
                                                }}
                                                onClick={() => handleOfficeValueClick(item.officeCode, item.officeNameEn, officeData.month, officeData.year, '11')}
                                            >
                                                {item.threeFps}
                                            </a>
                                        ) : (
                                            item.threeFps
                                        )}
                                    </td>
                                    <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>
                                        {item.fourFps > 0 ? (
                                            <a
                                                style={{
                                                    cursor: 'pointer',
                                                    color: 'black',
                                                    textDecoration: 'underline'
                                                }}
                                                onClick={() => handleOfficeValueClick(item.officeCode, item.officeNameEn, officeData.month, officeData.year, '16')}
                                            >
                                                {item.fourFps}
                                            </a>
                                        ) : (
                                            item.fourFps
                                        )}
                                    </td>
                                    <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>
                                        {item.fiveFps > 0 ? (
                                            <a
                                                style={{
                                                    cursor: 'pointer',
                                                    color: 'black',
                                                    textDecoration: 'underline'
                                                }}
                                                onClick={() => handleOfficeValueClick(item.officeCode, item.officeNameEn, officeData.month, officeData.year, '20')}
                                            >
                                                {item.fiveFps}
                                            </a>
                                        ) : (
                                            item.fiveFps
                                        )}
                                    </td>
                                </tr>
                            ))}

                            <tr  className="tableheader">
                                <td colSpan="2" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Total</td>
                                                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{officeData.zeroFps}</td>

                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{officeData.oneFps}</td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{officeData.twoFps}</td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{officeData.threeFps}</td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{officeData.fourFps}</td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{officeData.fiveFps}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}

            {/* fpsid logindays table */}
            {loindaysData && loindaysData.list && (
                <div ref={loindaysTableRef} style={{ marginBottom: '40px', marginTop: '30px' }}>
                    <table style={{
                        width: '70%',
                        margin: '0 auto',
                        borderCollapse: 'collapse',
                        border: '1px solid #ddd'
                    }}>
                        <tbody>
                            <tr  className="tableheader">
                                <td colSpan="12" style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>
                                    {getHeadingText()}
                                </td>
                            </tr>
                            <tr  className="tableheader">
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Sl No</td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>FPS Id</td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Dealer Name</td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Dealer Mobile</td>
                                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>Login Days</td>
                            </tr>

                            {loindaysData.list.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                        {index + 1}
                                    </td>
                                    <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                        {item.fpsId}
                                    </td>
                                    <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                        {item.ownerName}
                                    </td>
                                    <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                        {item.fpsMobileNo}
                                    </td>
                                    <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                                        {item.loginDays}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {showTopButton && (
                <button
                    onClick={scrollToTop}
                    style={{
                        position: 'fixed',
                        right: '18px',
                        bottom: '18px',
                        zIndex: 9999,
                        backgroundColor: '#f1872bff',
                        color: '#100d0dff',
                        border: 'none',
                        padding: '12px 14px',
                        borderRadius: '20px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        fontSize: '14px'
                    }}
                    title="Back to Top"
                >
                    Top
                </button>
            )}
        </div>
    );
};

export default FPS_Dist_Active_Details;